import { Components, Theme } from '@mui/material';

export function getComponents({ palette, breakpoints, zIndex }: Theme, options?: Components): Components {
    const borderLayout = `1px solid ${palette.grey['300']}`;

    return {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    borderBottom: borderLayout,
                    color: palette.primary.main,
                    backgroundColor: palette.background.paper,
                    zIndex: zIndex.drawer + 1,
                },
            },
            defaultProps: {
                elevation: 0,
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    '.MuiInputBase-root': { height: 'auto' },
                    width: '100%',
                },
            },
        },
        MuiBottomNavigation: {
            styleOverrides: {
                root: {
                    borderTop: borderLayout,
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    '&#widget': {
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                    },
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    padding: '8px 16px',
                    borderBottom: borderLayout,
                },
                title: {
                    fontSize: 18,
                    fontWeight: 'bolder',
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    flexGrow: 1,
                    '&:last-child': { paddingBottom: '16px' },
                },
            },
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    background: palette.background.default,
                    padding: '16px',
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    background: palette.background.default,
                    justifyContent: 'flex-start',
                    padding: '16px 24px',
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: '16px 24px !important',
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    padding: '16px 24px 8px 24px',
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                root: {
                    width: 245,
                    flexShrink: 0,
                },
                paper: {
                    paddingTop: 0,
                    width: 245,
                    boxSizing: 'border-box',
                    [breakpoints.down('lg')]: {
                        maxHeight: 'calc(100vh - 55px)',
                    },
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    label: { backgroundColor: palette.background.paper },
                    '&.filter .MuiSelect-select': { padding: '8px 0 8px 16px' },
                },
            },
            defaultProps: {
                fullWidth: true,
            },
        },
        MuiStack: {
            styleOverrides: {
                root: { width: '100%' },
            },
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    minHeight: 55,
                    alignItems: 'flex-end',
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                slotProps: {
                    inputLabel: { shrink: true },
                },
                fullWidth: true,
            },
        },
        MuiInputLabel: {
            defaultProps: {
                shrink: true,
            },
        },
        MuiListSubheader: {
            styleOverrides: {
                root: { fontVariant: 'all-small-caps' },
            },
        },
        MuiList: {
            styleOverrides: {
                root: {
                    paddingTop: 0,
                    paddingBottom: 0,
                },
            },
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    padding: '0px 6px 6px 6px',
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    [breakpoints.up('xs')]: {
                        height: 55,
                        minHeight: 55,
                        padding: '0px 12px',
                    },
                    '& #app-title': {
                        minWidth: '233px',
                        height: 'inherit',
                        borderRight: borderLayout,
                        img: { maxHeight: '100%', padding: '8px' },
                    },
                    '& .MuiTab-root': { minHeight: 55 },
                },
            },
        },
        ...options,
    };
}
